module.exports = __webpack_public_path__ + "img/huangdongxu.7d65fb59.png";